import { IAppState } from '../../types/redux';

export function selectShowHeader(state: IAppState) {
  return state.showHeader;
}
